import { AxleOrgSyncOrgFragment } from "../../../../../../types";
import { OrgsListBase, OrgsListBaseProps } from "./OrgsListBase";

type OrgsListSyncedProps = Omit<OrgsListBaseProps, "title" | "columnMode" | "onSync"> & {
  onSync: (org: AxleOrgSyncOrgFragment) => void;
  onRetryBatch: (org: AxleOrgSyncOrgFragment, batchIndex: number) => void;
  retryingBatchIndex: number | null;
};

export const OrgsListSynced = (props: OrgsListSyncedProps) => {
  return <OrgsListBase {...props} title="Synced Orgs" columnMode={"Sync"} />;
};
